import { Button as MuiButton, useTheme } from "@mui/material";
import React from "react";
import { ButtonProps } from "./Button.type";

const Button: React.FC<ButtonProps> = ({
  id = "",
  ref = undefined,
  onClick = () => {},
  text = "",
  isLoading = false,
  disabled = false,
  leftSide = false,
  rightSide = false,
  sx = {},
  iconDetails = {
    allowIcon: false,
    icon: null,
    iconSx: { padding: "0px 5px 0px 5px", height: "28px", width: "28px" },
  },
  variant = "contained",
  type = "button",
  color = "primary",
}) => {
  const theme = useTheme();
  const { allowIcon = false, icon = null, iconSx = {} } = iconDetails;

  // MUI icons are forwardRef/memo objects (not plain functions), so treat any
  // non-string icon as a React component; only string values are image URLs.
  const isReactComponent = icon != null && typeof icon !== "string";

  // Extract color from iconSx for React components (SVG icons that expect color prop)
  const { color: iconColor, ...iconStyle } = iconSx as any;

  return (
    <MuiButton
      ref={ref}
      data-testid={id}
      title={text}
      onClick={onClick}
      loading={isLoading}
      disabled={disabled || isLoading}
      color={color}
      type={type}
      sx={{
        textTransform: "none",
        height: "40px",
        borderColor: theme.palette.common.middleLightGrey,
        boxShadow: "none",
        borderRadius: "4px",
        width: "100px",
        whiteSpace: "nowrap",
        ...sx,
      }}
      variant={variant}>
      {leftSide && allowIcon ? (
        isReactComponent ? (
          React.createElement(icon, {
            style: { marginRight: "5px", ...iconStyle },
            color: iconColor,
          })
        ) : (
          <img alt="icon" src={icon} style={{ marginRight: "5px", ...iconSx }} />
        )
      ) : null}

      {text}

      {rightSide && allowIcon ? (
        isReactComponent ? (
          React.createElement(icon, {
            style: { marginLeft: "5px", ...iconStyle },
            color: iconColor,
          })
        ) : (
          <img alt="icon" src={icon} style={{ marginLeft: "5px", ...iconSx }} />
        )
      ) : null}
    </MuiButton>
  );
};

export default Button;
